import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { UserContext } from '../utils/UserContext';

const ACCENT = '#0f766e';
const ACCENT_SOFT = 'rgba(15, 118, 110, 0.10)';

const navItems = [
  { label: 'Dashboard', icon: 'bx bx-home-circle', path: '/patient/dashboard' },
  { label: 'My EHR', icon: 'bx bx-file', path: '/patient/dashboard/ehr' },
  { label: 'Service Requests', icon: 'bx bx-clipboard', path: '/patient/service-requests' },
  { label: 'Appointments', icon: 'bx bx-calendar', path: '/patient/appointments' },
  { label: 'Collaborations', icon: 'bx bx-network-chart', path: '/patient/collaborations' },
  { label: 'Telehealth', icon: 'bx bx-video', path: '/patient/telehealth' },
  { label: 'Billing', icon: 'bx bx-credit-card', path: '/patient/billing' },
  { label: 'Consents', icon: 'bx bx-check-shield', path: '/patient/consents' },
];

const PatientSidebar: React.FC = () => {
  const location = useLocation();
  const activePath = location.pathname;
  const user = useContext(UserContext);

  return (
    <aside style={{ minHeight: '100vh', width: 260, background: '#fff', borderRight: '1px solid var(--uzima-shell-border, #e9ecef)', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
      {/* Logo */}
      <div style={{ padding: '20px 24px', borderBottom: '1px solid var(--uzima-shell-border, #e9ecef)', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ width: 36, height: 36, borderRadius: 10, background: `linear-gradient(135deg, ${ACCENT}, #14b8a6)`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <i className="bx bx-plus-medical" style={{ color: '#fff', fontSize: '1.1rem' }}></i>
        </div>
        <div>
          <div style={{ fontWeight: 800, fontSize: '0.95rem', color: ACCENT, letterSpacing: '-0.02em' }}>Uzima</div>
          <div style={{ fontSize: '0.65rem', color: 'var(--uzima-shell-text-muted, #94a3b8)', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Patient Portal</div>
        </div>
      </div>

      {/* Navigation */}
      <nav style={{ flex: 1, padding: '16px 12px', overflowY: 'auto' }}>
        <div style={{ fontSize: '0.65rem', fontWeight: 700, color: 'var(--uzima-shell-text-muted, #94a3b8)', textTransform: 'uppercase', letterSpacing: '1px', padding: '0 12px', marginBottom: 8 }}>
          Navigation
        </div>
        {navItems.map(item => {
          const isActive = activePath === item.path || (item.path !== '/patient/dashboard' && activePath.startsWith(item.path));
          return (
            <Link key={item.label} to={item.path} style={{
              display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 10, marginBottom: 2,
              textDecoration: 'none', transition: 'all 0.15s',
              background: isActive ? ACCENT_SOFT : 'transparent',
              color: isActive ? ACCENT : 'var(--uzima-shell-text-soft, #475569)',
              fontWeight: isActive ? 600 : 400, fontSize: '0.84rem',
            }}>
              <i className={item.icon} style={{ fontSize: '1.1rem', width: 20, textAlign: 'center', color: isActive ? ACCENT : 'var(--uzima-shell-text-muted, #94a3b8)' }}></i>
              {item.label}
              {isActive && <div style={{ marginLeft: 'auto', width: 5, height: 5, borderRadius: '50%', background: ACCENT }}></div>}
            </Link>
          );
        })}
      </nav>

      {/* Bottom */}
      <div style={{ borderTop: '1px solid var(--uzima-shell-border, #e9ecef)', padding: '12px' }}>
        <Link to="/patient/settings" style={{
          display: 'flex', alignItems: 'center', gap: 10, padding: '8px 14px', borderRadius: 10,
          textDecoration: 'none', color: 'var(--uzima-shell-text-soft, #475569)', fontSize: '0.82rem',
        }}>
          <i className="bx bx-cog" style={{ fontSize: '1.05rem', color: 'var(--uzima-shell-text-muted, #94a3b8)' }}></i> Settings
        </Link>
        <Link to="/signout" style={{
          display: 'flex', alignItems: 'center', gap: 10, padding: '8px 14px', borderRadius: 10,
          textDecoration: 'none', color: '#e11d48', fontSize: '0.82rem',
        }}>
          <i className="bx bx-log-out" style={{ fontSize: '1.05rem' }}></i> Sign Out
        </Link>
      </div>

      {/* Profile */}
      <div style={{ borderTop: '1px solid var(--uzima-shell-border, #e9ecef)', padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{ width: 36, height: 36, borderRadius: '50%', background: `linear-gradient(135deg, ${ACCENT}, #14b8a6)`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 700, fontSize: '0.8rem', flexShrink: 0 }}>
          {(user?.name || 'P')[0].toUpperCase()}
        </div>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: '0.82rem', color: 'var(--uzima-shell-text, #0f172a)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.name || 'Patient'}</div>
          <div style={{ fontSize: '0.7rem', color: 'var(--uzima-shell-text-muted, #94a3b8)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{user?.email || 'patient@email.com'}</div>
        </div>
      </div>
    </aside>
  );
};

export default PatientSidebar; 